import { render } from "./MaxValue.vue?vue&type=template&id=4fd85400&ts=true"
import script from "./MaxValue.vue?vue&type=script&lang=ts"
export * from "./MaxValue.vue?vue&type=script&lang=ts"

import "./MaxValue.vue?vue&type=style&index=0&id=4fd85400&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__